import { cn } from '@/utlis/cn'
import { Field } from '@ark-ui/react'

type TextFieldProps = {
    className?: string
    label?: string
    rows?: number
    autoresize?: boolean
    placeholder?: string
    helperText?: string
    value?: string
    error?: string
    disabled?: boolean
    onChange?: (value: string) => void
    onKeyDown?: React.KeyboardEventHandler<HTMLTextAreaElement>
    onContextMenu?: React.MouseEventHandler<HTMLTextAreaElement>
}
export function TextField(props: TextFieldProps) {
    return (
        <Field.Root>
            {props.label && <Field.Label>{props.label}</Field.Label>}
            <Field.Textarea
                className={cn(
                    'rounded-[20px] border-1 border-white/5 bg-[rgba(255,255,255,0.08)] shadow-glow p-4 w-full placeholder:text-muse-fg/40',
                    props.className
                )}
                disabled={props.disabled}
                placeholder={props.placeholder}
                rows={props.rows}
                autoresize={props.autoresize}
                value={props.value}
                onChange={(ev) => props.onChange && props.onChange(ev.target.value)}
                onKeyDown={props.onKeyDown}
                onContextMenu={props.onContextMenu}
            />
            {props.helperText && <Field.HelperText>{props.helperText}</Field.HelperText>}
            {props.error && <Field.ErrorText>{props.error}</Field.ErrorText>}
        </Field.Root>
    )
}
